import { render } from "./LoadingLogo.vue?vue&type=template&id=1813afa8&scoped=true"
const script = {}

import "./LoadingLogo.vue?vue&type=style&index=0&id=1813afa8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1813afa8"]])

export default __exports__